import { memo } from "react";

import { isEmpty } from "lodash";

import {
  Stack,
  Box,
  SkeletonText,
  Text,
  Heading
} from "@/storybook-components";
import { stripAllHtml } from "@/lib";

const ViewPinDetails = ({ viewCardLoader, pinDetails }: any): any => {
  if (isEmpty(pinDetails))
    return (
      <SkeletonText isLoaded={viewCardLoader} noOfLines={9}>
        <Box></Box>
      </SkeletonText>
    );
  const answers = pinDetails?.answers;
  const updatedArray = [];
  !isEmpty(answers) &&
    Object.keys(answers).map((item) => updatedArray?.push(answers?.[item]));

  return updatedArray
    ?.sort((a, b) => a.sequence - b.sequence)
    .map((item, index) => {
      const itemAnswer = item?.answer;

      const answer =
        itemAnswer && Array.isArray(itemAnswer)
          ? itemAnswer?.map(({ value }) => value)?.join(", ")
          : itemAnswer?.value;

      const itemQuestion = (answer?.length && item?.question) || "";

      const isViewDetailsQuestion = [
        "Your Comment",
        "Add Image",
        "Eich sylw",
        "Ychwanegu delwedd",
        "Votre commentaire",
        "Ajouter une image",
        "Su comentario",
        "Agregar imagen"
      ];

      return !isViewDetailsQuestion.includes(itemQuestion) &&
        itemQuestion.length ? (
        <Stack pt="4" spacing="6" key={index}>
          <Box>
            <Heading size="xs">
              {itemQuestion?.[0]?.toUpperCase() + itemQuestion?.substring?.(1)}
            </Heading>
            <Text pt="2" fontSize={"md"} lineHeight={3}>
              {answer ? stripAllHtml(answer) : ""}
            </Text>
          </Box>
        </Stack>
      ) : null;
    });
};

export default memo(ViewPinDetails);
